import { initGrid } from 'utils/grid/grid';

import { RETAILER_TYPE } from 'app/validators/roles';
import { fetchSubordinateList } from '../../actions/subordinate-list.actions';

import template from './rw-subordinates-table.html';

const mapStateToThis = ({ session, subordinateList, ui, config }) => {
  const { list, isLoading } = subordinateList;
  const { pagination } = ui;
  const { retailer } = session;
  const { showDistrictColumn, defaultPageNo, sortColumnKey, directionKey } = config;

  return {
    list,
    isLoading,
    retailer,
    pagination,
    showDistrictColumn,
    defaultPageNo,
    sortColumnKey,
    directionKey,
  };
};

const mapDispatchToThis = {
  fetchSubordinateList,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications', 'tableService')
class RwSubordinatesTableController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.filterSubordinates = (context) => (subordinate) =>
      !((context === 'orders' || context === 'history') && subordinate.retailerType === RETAILER_TYPE.CHAIN_HEAD);

    this.headerText = this.context
      ? this.gettextCatalog.getString('Select a retailer number to view {{ context }} for.', { context: this.context })
      : null;
    this.filters = {};
    this.tableConfig = this.tableService.initConfig({ configName: 'subordinatesList' });
    this.headers = this.tableConfig.getHeaders(this.getHeaders());
    this.initDefaultSortColumn();
    this.gridModel = initGrid(this.fetchSubordinateList, this.defaultParams);
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getHeaders() {
    const headers = [
      {
        text: this.gettextCatalog.getString('Store No.'),
        field: 'storeNumber',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Retailer No.'),
        field: 'displayNumber',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Name'),
        field: 'businessName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Address'),
        field: 'street1',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Zip'),
        field: 'zipCode',
        sortable: true,
        textAlignment: 'text-right',
      },
    ];

    if (this.showDistrictColumn) {
      headers.splice(2, 0, {
        text: this.gettextCatalog.getString('Chain Region Code'),
        field: 'corporateAccountRegionCode',
        sortable: true,
      });
    }

    return headers;
  }

  initDefaultSortColumn() {
    this.defaultSortColumn = this.tableService.getFirstFieldName(this.headers);
    this.defaultSortDirection = 'desc';
    if (this.retailer.isChainHead && this.tableConfig.isAvailableField('displayNumber')) {
      this.defaultSortColumn = 'displayNumber';
      this.defaultSortDirection = 'asc';
    }
    this.defaultParams = {
      [this.sortColumnKey]: this.defaultSortColumn,
      [this.directionKey]: this.defaultSortDirection,
      retailerId: this.$state.params.retailerNo,
    };
  }

  search() {
    this.gridModel.applyFilters();
  }

  clearFilters() {
    this.gridModel = initGrid(this.fetchSubordinateList, this.defaultParams);
    return this.search();
  }
}

export default class RwSubordinatesTableComponent {
  constructor() {
    this.controller = RwSubordinatesTableController;
    this.template = template;
    this.bindings = {
      onRetailerClick: '&',
      context: '@',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/components/rw-subordinates-table/rw-subordinates-table-component.js